import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import GroupBySubject from "../GroupBy/Subject";
import Editor from "../Editor";
import TextContent from "../Annotation/TextContent";
import UserContent from "../Annotation/UserContent";
import UnverifiedWarning from "../UnverifiedWarning";

export default class GroupedList extends PureComponent {
  static displayName = "Annotation.List.GroupedBySelection";

  static propTypes = {
    loginHandler: PropTypes.func.isRequired,
    focusHandler: PropTypes.func,
    annotations: PropTypes.array,
    closeDrawer: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      editorVisible: false
    };
    this.annotateToggleRef = React.createRef();
  }

  showEditor = () => {
    this.setState({ editorVisible: true });
  };

  hideEditor = () => {
    this.setState({ editorVisible: false }, () => {
      if (this.annotateToggleRef.current)
        this.annotateToggleRef.current.focus();
    });
  };

  hasComments = group => {
    return group.annotations?.some(
      annotation => (annotation?.attributes?.commentsCount || 0) > 0
    );
  };

  render() {
    const {
      annotations,
      saveAnnotation,
      loginHandler,
      closeDrawer
    } = this.props;

    return (
      <div className="annotation-selection">
        <UnverifiedWarning />
        <ul className="selection-list">
          <GroupBySubject
            annotations={annotations}
            render={group => (
              <li key={group.selection.hash} className="annotation-detail">
                <TextContent
                  annotation={group.annotation}
                  selection={group.selection.subject}
                  onAnnotate={this.showEditor}
                  onLogin={loginHandler}
                  annotateToggleRef={this.annotateToggleRef}
                  focusHandler={this.props.focusHandler}
                />
                {this.state.editorVisible && (
                  <Editor
                    annotation={{ attributes: {} }}
                    cancel={this.hideEditor}
                    saveAnnotation={attr => saveAnnotation(attr, group)}
                  />
                )}
                <ul
                  className="annotation-list"
                  {...(group.annotations.length > 1 || this.hasComments(group)
                    ? {}
                    : { role: "presentation" })}
                >
                  {group.annotations.map(annotation => {
                    return (
                      <UserContent
                        key={annotation.id}
                        annotation={annotation}
                        showLogin={loginHandler}
                        closeDrawer={closeDrawer}
                      />
                    );
                  })}
                </ul>
              </li>
            )}
          />
        </ul>
      </div>
    );
  }
}
